"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBGRAPH_URLS = void 0;
exports.SUBGRAPH_URLS = {
    mainnet: {
        indexedCore: 'https://api.thegraph.com/subgraphs/name/indexed-finance/indexed',
        uniswap: 'https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v2',
        indexedStaking: 'https://api.thegraph.com/subgraphs/name/indexed-finance/staking'
    },
    rinkeby: {
        indexedCore: 'https://api.thegraph.com/subgraphs/name/indexed-finance/indexed-rinkeby',
        uniswap: 'https://api.thegraph.com/subgraphs/name/samgos/uniswap-v2-rinkeby',
        indexedStaking: 'https://api.thegraph.com/subgraphs/name/indexed-finance/rinkeby-staking'
    }
};
